import { BaSeTheme, BaSeTooltip } from '@base/react';
import * as React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { BoxTag } from './data-table-styled';
import { Tag } from './tag';

export const InterviewResult = ({ props }) => {
  const { getStatusInterview, getDates } = useInterviewController();
  const [result, setResult] = React.useState('');
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    if (props.sendingResultEmail) {
      setData(getDates(props.sendingResultEmail, 'Enviado: ', 'Aberto: '));
    }
  }, [getDates, props]);
  React.useEffect(() => {
    setResult(getStatusInterview(props));
  }, [getStatusInterview, props]);

  const getStatusEmailResult = React.useCallback(
    (tagKey, icon) => {
      return (
        <BoxTag
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)}
        >
          <Tag tagKey={tagKey} label={result} icon={icon} />
          {data.sendEmailDate !== '' && data.openedEmailDate !== '' && (
            <BaSeTooltip
              color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              direction="bottom"
              coordinates={{ top: '34px' }}
              message={[data.sendEmailDate, data.openedEmailDate]}
              messageNoBreakLine
              open={tooltipOpen}
            />
          )}
        </BoxTag>
      );
    },
    [data.openedEmailDate, data.sendEmailDate, result, tooltipOpen],
  );

  const getDefaultInterview = React.useCallback(() => {
    return <Tag tagKey="default" label={result} />;
  }, [result]);

  const statusInterviewMap = {
    APTO: getStatusEmailResult('check', 'check'),
    NAO_APTO: getStatusEmailResult('nao_apto', 'ban'),
    CONCLUIDO: getStatusEmailResult('check', 'check'),
    AGUARDANDO_AVALIACAO: getStatusEmailResult('pending', 'clock'),
    // SEM_RESULTADO: getStatusEmailResult('default', 'close'),
  };
  return statusInterviewMap?.[props.statusInterview] ?? getDefaultInterview();
};
